import { Row, Col, Form, Button, Modal, Table } from 'react-bootstrap';
import "./LogOrderModal.css";
import {  useState } from 'react';
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const LogOrderModal = ({ show, requestClose, orderID }) => {

    //ENV VARIABLE
    const apiUrl = process.env.REACT_APP_API_URL;

    const [logTable, setLogTable] = useState([]);

    const [waitingFlag, setWaitingFlag] = useState(false);

    const populateTable = (responseContent) =>{

        //
        setWaitingFlag(false);

        setLogTable(responseContent);

    }

    const requestOrderLog = async () =>{


        //
        setWaitingFlag(true);

        //RESET TABLE
        setLogTable([]);

        //
        const endpoint = "getOrderLog?orderID=" + orderID;

        const response = await fetch(apiUrl + endpoint,
        {
            method: "GET",
            headers: {"Content-Type": "application/json"}
        });

        //
        const responseContent = await response.json();
        populateTable(responseContent);

    } //END FUNCTION
    

    return (
        <>
        <Modal show={show} onShow={requestOrderLog} onHide={requestClose} className={'mainOrderModal modal-xl'}>
            <Modal.Header closeButton style={{borderTop:'10px solid #404661'}}>
                <Modal.Title className={'newOrderTitle'}>Bitácora de Eventos | <b style={{color:"darkred"}}>N° {orderID}</b></Modal.Title>
            </Modal.Header>
            <Modal.Body>

                

                <Row style={{paddingLeft: "20px", paddingRight: "20px"}}>
                    <Col xs={12}>
                    <Table striped className="mainTable" style={{fontSize:"13px"}}>
                        <thead>
                            <tr>
                                <th>Fecha</th>
                                <th>Usuario</th>
                                <th>Descripción</th>
                                <th>Observaciones</th>
                            </tr>
                        </thead>
                        <tbody>

                            {waitingFlag ? <tr>
                                           <td colSpan={4} style={{textAlign: "center", color: "darkred"}}>
                                                <FontAwesomeIcon 
                                                    spin
                                                    icon={faCircleNotch } 
                                                    style={{}} 
                                                  /> Obteniendo datos, por favor espere...
                                            </td>
                                            </tr> : ""}

                            {logTable.length > 0 && logTable.map((item)=>{

                                return (
                                    <tr>
                                        <td>{item.timestamp}</td>
                                        <td>{item.user}</td>
                                        <td>{item.description}</td>
                                        <td><pre style={{whiteSpace: "pre-wrap", wordBreak: "break-word", fontFamily:"Arial", fontSize: "13px" }}>{item.notes.replace(/\\n/g, '\n')}</pre></td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                    </Col>
                </Row>


            </Modal.Body>
            <Modal.Footer>
            <Button variant="danger" onClick={requestClose} size='sm'>
                Cerrar Ventana
            </Button>
            </Modal.Footer>
        </Modal>
        </>
    );
}

export default LogOrderModal;